export default function RewardProgressBar({ completed = 0, total = 8, size = "sm", trackClassName = "" }) {
  const safeTotal = Math.max(1, total || 8);
  const safeCompleted = Math.max(0, Math.min(completed || 0, safeTotal));
  const percentage = Math.round((safeCompleted / safeTotal) * 100);

  return (
    <div className={`w-full ${size === "sm" ? "max-w-[120px]" : "max-w-[200px]"}`}>
      <div className="flex justify-between text-xs mb-1 text-inherit">
        <span>{safeCompleted}/{safeTotal} Rewards</span>
        <span>{percentage}%</span>
      </div>
      <div className={`w-full bg-gray-200/30 rounded-full h-2 overflow-hidden ${trackClassName}`}>
        <div
          className="bg-theme_clr2 h-full rounded-full transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
